import { DEFAULT_CURRENCY } from "@faire/retailer-visitor-shared/consts/DEFAULT_CURRENCY";
import { getRetailer } from "@faire/retailer-visitor-shared/serialized-data/getRetailer";
import { useSettingAndAssignMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useQuery as useRetailerQuery } from "@faire/web-api--source/api/retailer/retailerToken/get-hooks";
export var useRetailer = function() {
    var shouldUseHooksMigration = useSettingAndAssignMigrateRetailerStore();
    var serializedRetailer = getRetailer();
    var _useRetailerStore = useRetailerStore([
        "retailer",
        "retailerToken",
        "refetchRetailer",
        "retailerName",
        "faireCredit",
        "currency",
        "showR2B"
    ]), retailerControl = _useRetailerStore.retailer, retailerTokenControl = _useRetailerStore.retailerToken, refetchRetailerControl = _useRetailerStore.refetchRetailer, retailerNameControl = _useRetailerStore.retailerName, faireCreditControl = _useRetailerStore.faireCredit, currencyControl = _useRetailerStore.currency, showR2BControl = _useRetailerStore.showR2B;
    var _serializedRetailer_token;
    var _useRetailerQuery = useRetailerQuery((_serializedRetailer_token = serializedRetailer === null || serializedRetailer === void 0 ? void 0 : serializedRetailer.token) !== null && _serializedRetailer_token !== void 0 ? _serializedRetailer_token : "", undefined, {
        enabled: !!(serializedRetailer === null || serializedRetailer === void 0 ? void 0 : serializedRetailer.token),
        initialData: serializedRetailer,
        refetchOnMount: false
    }), retailer = _useRetailerQuery.data, refetchRetailer = _useRetailerQuery.refetch;
    var retailerName = retailer === null || retailer === void 0 ? void 0 : retailer.name;
    var retailerToken = retailer === null || retailer === void 0 ? void 0 : retailer.token;
    var faireCredit = retailer && retailer.available_balance_cents || 0;
    var _retailer_currency;
    var currency = (_retailer_currency = retailer === null || retailer === void 0 ? void 0 : retailer.currency) !== null && _retailer_currency !== void 0 ? _retailer_currency : DEFAULT_CURRENCY;
    var showR2B = !!retailer && !retailer.hide_retailer2_maker;
    if (shouldUseHooksMigration) {
        return {
            retailer: retailer,
            retailerToken: retailerToken,
            refetchRetailer: refetchRetailer,
            retailerName: retailerName,
            faireCredit: faireCredit,
            currency: currency,
            showR2B: showR2B
        };
    }
    return {
        retailer: retailerControl,
        retailerToken: retailerTokenControl,
        refetchRetailer: refetchRetailerControl,
        retailerName: retailerNameControl,
        faireCredit: faireCreditControl,
        currency: currencyControl,
        showR2B: showR2BControl
    };
};
